import Splide from '@splidejs/splide';
import { initSliderControls } from '../utils/slider-controls';

const initBlogCategorySlider = (section) => {
  if (section.dataset.blogCategorySliderReady === 'true') {
    return;
  }

  const sliderElement = section.querySelector('.blog-category-slider__slider');
  const slides = Array.from(
    sliderElement?.querySelectorAll('.splide__slide') || []
  );
  const slideCount = slides.length;

  if (!sliderElement || !slideCount) {
    return;
  }

  const canLoop = slideCount > 1;

  // The track runs to the viewport edge, so Splide's default single clone
  // leaves gaps. Clone enough slides to always cover the visible width.
  const getCloneCount = () => {
    const slideWidth = slides[0].getBoundingClientRect().width || 230;
    const trackWidth = sliderElement.getBoundingClientRect().width;

    return Math.max(slideCount, Math.ceil(trackWidth / slideWidth) + 1);
  };

  const slider = new Splide(sliderElement, {
    arrows: false,
    autoWidth: true,
    clones: canLoop ? getCloneCount() : 0,
    drag: canLoop,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    gap: 'clamp(16px, 1.46vw, 28px)',
    keyboard: 'focused',
    pagination: false,
    perMove: 1,
    type: canLoop ? 'loop' : 'slide',
  });

  initSliderControls({
    section,
    slider,
    slides,
    progressBar: section.querySelector('[data-blog-category-progress]'),
    progressThumb: section.querySelector('[data-blog-category-thumb]'),
    interval: 4000,
    speed: 700,
    getSlideLabel: (slide) =>
      slide?.querySelector('.blog-category-slider__name')?.textContent.trim(),
  });

  slider.on('resized', () => {
    if (!canLoop) return;

    const clones = getCloneCount();
    if (slider.options.clones !== clones) slider.options = { clones };
  });
  slider.mount();

  section.dataset.blogCategorySliderReady = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-blog-category-slider]')
    .forEach(initBlogCategorySlider);
});
